import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component
export class DTButton extends Vue {
  @Prop({ default: 'OK' }) text;
  @Prop({ default: '' }) classNames;

  onClick(e) {
    this.$emit('click', e);
  }

  render(createElement) {
    return (
      <button class={`dt-button ${this.classNames}`} onClick={this.onClick}>
        {this.$slots.default}
      </button>
    );
  }
}

@Component
export class DTIconButton extends DTButton {
  @Prop({ default: 'add' }) icon;
  @Prop({ default: 'add' }) text;
  @Prop({ default: 16 }) size;

  onClick(e) {
    this.$emit('click', e);
  }
  render(createElement) {
    return (
      <DTButton classNames={`dtlink dtlink--icon ${this.classNames}`} onClick={this.onClick}>
        <div class="dt-icon-container">
          <img
            class="dt-icon s1"
            src={`static/icons/${this.icon}.svg`}
            alt="search"
          />
        </div>
        {this.text ? <span>{this.text}</span> : undefined}
      </DTButton>
    );
  }
}
@Component
export class IconButton extends DTButton {
  @Prop({ default: 'add' }) icon;
  @Prop({ default: 16 }) size;
  @Prop({ default: 4 }) padding;
  @Prop({ default: 'sprt-85' }) bcHover;


  onClick(e) {
    this.$emit('click', e);
  }
  render(createElement) {
    return (
      <DTButton style={{
        '--bc-hover': `var(--${this.bcHover})`,
      }} classNames={`dt-icon-button ${this.classNames}`} onClick={this.onClick}>
        <div class="ut-colcen" style={{
          padding: `${this.padding}px`
        }}>
          <img
            style={
              {
                height: `${this.size}px`,
                width: `${this.size}px`,
              }
            }
            src={`static/icons/${this.icon}.svg`}
            alt="search"
          />
        </div>
      </DTButton>
    );
  }
}

